import { alpha, Box, Typography, useTheme } from '@mui/material';

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: theme.colors.alpha.white[50],
        textAlign: 'center',
        py: 1,
        boxShadow: `0px 2px 8px -3px ${alpha(
          theme.colors.alpha.black[100],
          0.2
        )}, 0px 5px 22px -4px ${alpha(theme.colors.alpha.black[100], 0.1)}`
      }}
    >
      <Typography fontWeight={600} fontSize={16}>
        Developed By{' '}
        <Box
          component="a"
          sx={{ color: '#1b9cd7' }}
          href="https://asmartech.ae"
          fontWeight={700}
          target="_blank"
        >
          Asmartech
        </Box>
      </Typography>
    </Box>
  );
};

export default Footer;
